module.exports = {
	"id": "SN",
	"name": "Senegal",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.009212,
			"5": 0.013818,
			"6": 0.027636,
			"7": 0.004606,
			"8": 0.009212,
			"9": 0.009212,
			"10": 0.013818,
			"11": 0.082908,
			"12": 0.027636,
			"13": 0.013818,
			"14": 0.013818,
			"15": 0.009212,
			"16": 0.036848,
			"17": 0.027636,
			"18": 0.018424,
			"19": 0.027636,
			"20": 0.004606,
			"21": 0.004606,
			"22": 0.009212,
			"23": null,
			"24": 0.004606,
			"25": 0.013818,
			"26": 0.018424,
			"27": 0.013818,
			"28": 0.027636,
			"29": 0.027636,
			"30": 0.027636,
			"31": 0.04606,
			"32": 0.032242,
			"33": 0.055272,
			"34": 0.018424,
			"35": 0.032242,
			"36": 0.02303,
			"37": 0.013818,
			"38": 0.018424,
			"39": 0.027636,
			"40": 0.041454,
			"41": 0.013818,
			"42": 0.032242,
			"43": 0.336238,
			"44": 0.036848,
			"45": 0.082908,
			"46": 0.050666,
			"47": 0.257936,
			"48": 0.087514,
			"49": 1.699614,
			"50": 0.156604,
			"51": 0.718536,
			"52": 0.363874,
			"53": 16.162454,
			"54": 4.76721,
			"55": 0.04606,
			"56": 0.009212,
			"57": null
		},
		"firefox": {
			"2": 0.004606,
			"3": 0.036848,
			"4": 0.009212,
			"5": null,
			"6": 0.004606,
			"7": null,
			"8": 0.009212,
			"9": null,
			"10": 0.018424,
			"11": 0.027636,
			"12": 0.036848,
			"13": 0.009212,
			"14": 0.009212,
			"15": 0.050666,
			"16": 0.02303,
			"17": 0.009212,
			"18": 0.009212,
			"19": 0.013818,
			"20": 0.009212,
			"21": 0.027636,
			"22": 0.013818,
			"23": 0.013818,
			"24": 0.004606,
			"25": 0.009212,
			"26": 0.013818,
			"27": 0.06909,
			"28": 0.013818,
			"29": 0.02303,
			"30": 0.036848,
			"31": 0.055272,
			"32": 0.027636,
			"33": 0.02303,
			"34": 0.032242,
			"35": 0.050666,
			"36": 0.04606,
			"37": 0.055272,
			"38": 0.198058,
			"39": 0.055272,
			"40": 0.050666,
			"41": 0.073696,
			"42": 0.050666,
			"43": 0.515872,
			"44": 0.119756,
			"45": 0.175028,
			"46": 0.142786,
			"47": 0.999502,
			"48": 0.73696,
			"49": 6.936636,
			"50": 0.133574,
			"51": 0.009212,
			"52": null,
			"3.5": 0.009212,
			"3.6": 0.050666
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.004606,
			"21": 0.009212,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.013818,
			"30": 0.013818,
			"31": null,
			"32": 0.004606,
			"33": 0.013818,
			"34": 0.009212,
			"35": 0.004606,
			"36": 0.050666,
			"37": 0.050666,
			"38": 0.04606,
			"39": 0.032242,
			"40": 0.635628,
			"41": 0.11515,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.004606,
			"12.1": 0.013818
		},
		"safari": {
			"0": null,
			"4": 0.02303,
			"5": 0.036848,
			"6": 0.013818,
			"7": 0.013818,
			"8": 0.124362,
			"9": 0.16121,
			"10": 0.428358,
			"3.1": null,
			"3.2": null,
			"5.1": 0.050666,
			"6.1": 0.018424,
			"7.1": 0.009212,
			"9.1": 0.271754
		},
		"ios_saf": {
			"8": 0,
			"10": 3.00092384846,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0808714252706,
			"8.1-8.4": 0.149406531432,
			"9.0-9.2": 0.071276510408,
			"9.3": 1.08742368443
		},
		"android": {
			"3": 0,
			"4": 0.175976237726,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0219970297158,
			"4.1": 0.634771428941,
			"4.2-4.3": 1.58692857235,
			"4.4": 3.63893720155,
			"4.4.3-4.4.4": 3.67036152972
		},
		"ie": {
			"6": null,
			"7": 0.013818,
			"8": 0.294784,
			"9": 0.119756,
			"10": 0.244118,
			"11": 2.02664,
			"5.5": null
		},
		"op_mob": {
			"0": 0.355551261733,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00987642393703
		},
		"edge": {
			"12": 0.13818,
			"13": 0.382298,
			"14": 0.32242
		},
		"ie_mob": {
			"10": 0.592318507042,
			"11": 2.41158249296
		},
		"bb": {
			"7": 0.06067125,
			"10": null
		},
		"samsung": {
			"0": 4.15261
		},
		"and_uc": {
			"0": 1.110958
		},
		"op_mini": {
			"0": 4.79028031433
		},
		"and_chr": {
			"0": 27.438215
		},
		"and_ff": {
			"0": 0.86288
		}
	},
	"total": 98.30204725
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SN.json
 ** module id = 648
 ** module chunks = 0
 **/